import { Application } from "@hotwired/stimulus"
import TC from "@rolemodel/turbo-confirm"

TC.start()

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

import Sortable from '@stimulus-components/sortable'
application.register('sortable', Sortable)

import TextareaAutogrow from 'stimulus-textarea-autogrow'
application.register('textarea-autogrow', TextareaAutogrow)

import ToastController from "../../components/toast/toast_controller"
application.register("toast", ToastController)

import FlashController from "../../components/flash/flash_controller"
application.register("flash", FlashController)

import Clipboard from '@stimulus-components/clipboard'
application.register("clipboard", Clipboard)
export { application }
